export type SmartCaptchaWidgetId = number | string;

export type SmartCaptchaApi = {
  render: (
    container: HTMLElement,
    options: {
      sitekey: string;
      invisible: boolean;
      hl?: string;
      shieldPosition?: string;
      callback: (token: string) => void;
    },
  ) => SmartCaptchaWidgetId;
  execute: (widgetId?: SmartCaptchaWidgetId) => void;
  reset: (widgetId?: SmartCaptchaWidgetId) => void;
  destroy: (widgetId?: SmartCaptchaWidgetId) => void;
};

declare global {
  interface Window {
    smartCaptcha?: SmartCaptchaApi;
  }
}

const SCRIPT_ID = "yandex-smartcaptcha-script";
let loaderPromise: Promise<SmartCaptchaApi> | null = null;

export function loadYandexSmartCaptcha() {
  if (!import.meta.client) {
    return Promise.reject(new Error("SmartCaptcha доступна только в браузере."));
  }

  if (window.smartCaptcha) return Promise.resolve(window.smartCaptcha);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise<SmartCaptchaApi>((resolve, reject) => {
    const resolveApi = () => {
      if (window.smartCaptcha) {
        resolve(window.smartCaptcha);
      } else {
        loaderPromise = null;
        reject(new Error("Не удалось загрузить SmartCaptcha."));
      }
    };
    const rejectLoad = () => {
      loaderPromise = null;
      reject(new Error("Не удалось загрузить SmartCaptcha."));
    };
    const existingScript = document.getElementById(
      SCRIPT_ID,
    ) as HTMLScriptElement | null;

    if (existingScript) {
      existingScript.addEventListener("load", resolveApi, { once: true });
      existingScript.addEventListener("error", rejectLoad, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src =
      "https://smartcaptcha.cloud.yandex.ru/captcha.js?render=onload";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", resolveApi, { once: true });
    script.addEventListener("error", rejectLoad, { once: true });
    document.head.append(script);
  });

  return loaderPromise;
}

export function getSmartCaptchaHeaders(token: string) {
  return token ? { "x-smartcaptcha-token": token } : {};
}
